/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Model, { attr } from '@ember-data/model';
import { ScheduledContentUpdateStatus } from 'embercom/services/scheduled-content-update-service';
import type IntlService from 'ember-intl/services/intl';

/**
 * Minimal read-only model for Ember Data relationship.
 * Use ScheduledContentUpdateService for all operations (create, update, cancel).
 */
export default class ScheduledContentUpdate extends Model {
  @attr('number') declare appId: number;
  @attr('number') declare entityId: number;
  @attr('number') declare entityVersionId: number;
  @attr('number') declare entityType: number;
  @attr('string') declare status: string;
  @attr('string') declare contentUpdateType: string;
  @attr('date') declare changeAt: Date;
  @attr('number') declare adminId: number;
  @attr('string') declare metadata: string;
  @attr('date') declare createdAt: Date;
  @attr('date') declare updatedAt: Date;

  static getScheduleDateAndTime(
    scheduledContentUpdate: ScheduledContentUpdate,
    timezone: string,
    intl: IntlService,
  ): string[] | null {
    if (scheduledContentUpdate.status !== ScheduledContentUpdateStatus.PENDING) {
      return null;
    }

    let formattedDate = intl.formatDate(scheduledContentUpdate.changeAt, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      timeZone: timezone,
    });
    let formattedTime = intl.formatTime(scheduledContentUpdate.changeAt, {
      hour: 'numeric',
      minute: '2-digit',
      timeZone: timezone,
    });

    return [formattedDate, formattedTime];
  }

  static getScheduleDisplayText(
    scheduledContentUpdate: ScheduledContentUpdate,
    timezone: string,
    intl: IntlService,
  ): string | null {
    let result = this.getScheduleDateAndTime(scheduledContentUpdate, timezone, intl);

    if (!result) {
      return null;
    }

    let [date, time] = result;
    return intl.t(
      'knowledge-hub.content-editor.article-content.schedule-modal.current-schedule-short',
      { date, time },
    );
  }
}
